export const hideFooterEmailSignup = () => {
  if ($('.emailSignupPage').length > 0) {
    $('.mobilePage').length > 0 ? $('#mobile-footer #emailSignUpModal').remove() : $('.footer-links #emailSignUpModal').remove();
  }
}
